enum ApplicationPortal {
    OCTANE = 'Octane',
    BUFFALO = 'brp-financial',
    FOREST_RIVER = 'forest-river',
}

export default ApplicationPortal
